import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContractSignature, ContractToSign } from '@models/index';
import { EndpointParams } from '@models/utils/endpoint-params';

import { HttpService } from '@services/http.service';
import { InternationalizationService } from '@services/utils/internationalization/internationalization.service';

// Firma solicitada desde Manager (TD-15979): sin sesion de usuario, identificada por el token de la
// URL `/contract-signature?token={guid}`. Un token es un contrato y vale 30 dias desde la solicitud.
//
// Mismas dos reglas que `PublicContractSignatureSessionService`: `language_code` en la query para que
// los errores no salgan en ingles, y el token de reCAPTCHA v3 tambien en la query (`?recaptcha=`),
// porque ambos endpoints lo validan y sin el responden 400.
@Injectable({
    providedIn: 'root'
})
export class PublicContractSignatureService extends HttpService {
    private readonly internationalizationService = inject(InternationalizationService);

    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    search(token: string, recaptchaToken: string): Observable<ContractToSign> {
        return this.get(`public/contracts/${token}${this.buildQuery(recaptchaToken)}`, this.defaultEndpointParams).pipe(map((response) => new ContractToSign().build(response)));
    }

    sign(token: string, signature: ContractSignature, recaptchaToken: string): Observable<void> {
        return this.post(`public/contracts/${token}/sign${this.buildQuery(recaptchaToken)}`, this.defaultEndpointParams, signature);
    }

    private buildQuery(recaptchaToken: string): string {
        return `?language_code=${this.internationalizationService.getLanguage()}&recaptcha=${recaptchaToken}`;
    }
}
